import Vue from 'vue'
import Postbox from '@livebungalow/toolbox/postbox'
import { httpErrorLogger } from './sentry'

const httpConfig = {
  prefixUrl: process.env.VUE_APP_BACKEND_URL,
}

Vue.use(Postbox, httpConfig, httpErrorLogger)
